<template>
  <transition name="confirm-fade">
    <div 
      v-if="isVisible" 
      class="confirm-overlay" 
      @click.self="onCancel"
    >
      <div 
        class="confirm-dialog" 
        role="alertdialog" 
        aria-modal="true"
      >
        <p class="confirm-message">
          {{ dialogMessage }}
        </p>
        <div class="confirm-actions">
          <button 
            class="confirm-btn confirm-btn--cancel" 
            @click="onCancel"
          >
            {{ dialogCancelText }}
          </button>
          <button 
            class="confirm-btn confirm-btn--ok" 
            @click="onOk"
          >
            {{ dialogOkText }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: 'Start a new Version? Unsaved changes on the current canvas will be lost.',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    okText: {
      type: String,
      default: 'OK',
    },
  },

  data() {
    return {
      isVisible: this.visible,
      dialogMessage: this.message,
      dialogCancelText: this.cancelText,
      dialogOkText: this.okText,
      resolveDialog: null,
    };
  },

  mounted() {
    window.displayBuilderConfirm = this.open;
  },

  beforeDestroy() {
    if (window.displayBuilderConfirm === this.open) {
      delete window.displayBuilderConfirm;
    }
  },

  methods: {
    open(options = {}) {
      if (this.resolveDialog) {
        this.resolveDialog(false);
      }

      this.dialogMessage = options.message || this.message;
      this.dialogCancelText = options.cancelText || this.cancelText;
      this.dialogOkText = options.okText || this.okText;
      this.isVisible = true;

      return new Promise((resolve) => {
        this.resolveDialog = resolve;
      });
    },
    onCancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
      this.isVisible = false;
      this.resolveDialog?.(false);
      this.resolveDialog = null;
    },
    onOk() {
      this.$emit('ok');
      this.$emit('update:visible', false);
      this.isVisible = false;
      this.resolveDialog?.(true);
      this.resolveDialog = null;
    },
  },
};
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: rgba(0, 0, 0, 0.12);
  padding-top: 60px;
}

.confirm-dialog {
  background: #ffffff;
  border-radius: 12px;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.07),
    0 12px 32px rgba(0, 0, 0, 0.13);
  padding: 20px 22px 16px;
  min-width: 280px;
  max-width: 360px;
  width: 100%;
  font-family: -apple-system, 'Segoe UI', Roboto, sans-serif;
}

.confirm-message {
  font-size: 13.5px;
  line-height: 1.5;
  color: #1f1f1f;
  margin: 0 0 18px;
  font-weight: 400;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.confirm-btn {
  padding: 7px 20px;
  border-radius: 20px;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  outline: none;
  transition: filter 0.15s ease, background 0.15s ease;
  line-height: 1.4;
}

.confirm-btn--cancel {
  background: #e8eaed;
  color: #3c4043;
}

.confirm-btn--cancel:hover {
  background: #dadce0;
}

.confirm-btn--cancel:active {
  background: #cdd0d5;
}

.confirm-btn--ok {
  background: #1a73e8;
  color: #ffffff;
}

.confirm-btn--ok:hover {
  background: #1765cc;
}

.confirm-btn--ok:active {
  background: #155ab0;
}

/* Transition */
.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.15s ease;
}
.confirm-fade-enter,
.confirm-fade-leave-to {
  opacity: 0;
}
</style>
